import { createTheme } from '@mui/material/styles';

const Theme = createTheme({
    palette: {
        primary: {
            main: '#DB6015',
        },
        secondary: {
            main: '#f44336',
        },
    },
});
export default Theme;
